module.exports = __webpack_public_path__ + "static/img/zl.fc9a4112.png";